import { render, staticRenderFns } from "./BDXManagementTableFiltersPaymentStatus.vue?vue&type=template&id=2595117a"
import script from "./BDXManagementTableFiltersPaymentStatus.vue?vue&type=script&lang=js"
export * from "./BDXManagementTableFiltersPaymentStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports